import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Route42Logo } from '../components/brand/Route42Logo';
import { useAuth } from './AuthProvider';
import { hasUnavailableOrganizationAccess } from './organization-access';

export function ProtectedRoute() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.loading) {
    return (
      <main className="r42-boot" aria-live="polite">
        <Route42Logo variant="mark" />
        <p>Loading your Route42 workspace…</p>
      </main>
    );
  }

  if (!auth.profile) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }

  const available = auth.profile.memberships.filter((membership) => membership.access_available);
  const isProductTour = location.pathname === '/tour' || location.pathname.startsWith('/tour/');
  const isOrganizationSelection = location.pathname === '/organizations' || location.pathname === '/customers';
  const isOrganizationUnavailable = location.pathname === '/organization-unavailable';
  const unavailableMemberships = auth.profile.memberships.filter(hasUnavailableOrganizationAccess);

  if (!available.length && unavailableMemberships.length && !isOrganizationUnavailable) {
    const organization = encodeURIComponent(unavailableMemberships[0].customer_id);
    return <Navigate to={`/organization-unavailable?organization=${organization}`} replace />;
  }
  if (!auth.activeCustomerId && available.length > 1 && !isOrganizationSelection && !isOrganizationUnavailable && !isProductTour) {
    return <Navigate to="/organizations" replace />;
  }

  return <Outlet />;
}
